import { createContext, useContext, type ReactNode } from "react";

/*
地図 (LgSkillMap) の中の行き先に「受講生のみ」の錠を付ける決まり。体験の人の学習パスの地図が渡す。
渡さなければ (受講生、管理者、ダッシュボードの帯) 錠は無い。どの行き先に錠を付けるかは渡す側が決め、ここは住所を持たない。
行 (見るだけの行き先) は押せるまま錠の札を足し、操作のボタン (開く、予定を見る) は LgMembersOnlyButton に替える
*/
export type LgSkillMapLock = {
  /** この行き先を体験の人が使えないとき true */
  isLocked: (href: string) => boolean;
  /** 錠の札の字。無ければ「受講生のみ」(実プロダクト開発演習パスは「演習の参加者のみ」) */
  label?: (href: string) => string | undefined;
  /** 「次はここ」の開く釦の代わりに置く物。無ければ体験の人と同じ「受講生のみ」の釦 */
  action?: (href: string, label: string) => ReactNode;
};

export const LgSkillMapLockContext = createContext<LgSkillMapLock | null>(null);

export function useSkillMapLock(): LgSkillMapLock | null {
  return useContext(LgSkillMapLockContext);
}

/** 錠が付くか */
export function isLockedFor(lock: LgSkillMapLock | null, href: string): boolean {
  return Boolean(lock && lock.isLocked(href));
}

/** 2 つの錠を重ねる。先に渡した錠が付く行き先は、その錠の札と釦を使う */
export function composeLocks(first: LgSkillMapLock, second: LgSkillMapLock): LgSkillMapLock {
  const pick = (href: string) => (first.isLocked(href) ? first : second);
  return {
    isLocked: (href) => first.isLocked(href) || second.isLocked(href),
    label: (href) => pick(href).label?.(href),
    action: (href, label) => pick(href).action?.(href, label),
  };
}
